import { LOADING_SPINNER, PROFILE_MODEL, RULES_MODEL, RACE_CONDITION_MODEL, SUSPICIOUS_ACTIVITY_MODEL, CHECK_USER_STILL_MODEL, LEVEL_ACHIEVED_MODEL, NO_TESTDRIVE_BOT, CLEAR_REDUX } from "../actionTypes";

const initialState = {
    loading: true,
    ruleModel: false,
    raceConditionModel: false,
    checkUserStillModel: false,
    suspiciousActivityModel: false,
    profileModel: false,
    levelAchievedModel: false,
    noTestDriveModel: false
}

export const loadingSpinnerReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOADING_SPINNER:
            return {
                ...state,
                loading: action.payload
            };
        case PROFILE_MODEL:
            return {
                ...state,
                profileModel: action.payload
            };
        case RULES_MODEL:
            return {
                ...state,
                ruleModel: action.payload
            };
        case RACE_CONDITION_MODEL:
            return {
                ...state,
                raceConditionModel: action.payload
            };
        case CHECK_USER_STILL_MODEL:
            return {
                ...state,
                checkUserStillModel: action.payload
            };
        case SUSPICIOUS_ACTIVITY_MODEL:
            return {
                ...state,
                suspiciousActivityModel: action.payload
            };
        case LEVEL_ACHIEVED_MODEL:
            return {
                ...state,
                levelAchievedModel: action.payload
            }
        case NO_TESTDRIVE_BOT:
            return {
                ...state,
                noTestDriveModel: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}